/* eslint-disable import/no-anonymous-default-export */
import { makeAutoObservable } from "mobx";
import { ToolStateType } from "../types/storeType";
import socketState from "./socketState";
import { FigureTypes, MessageMethod, MessageType } from "../types/types";

class ToolState {
    tool: ToolStateType = null;

    constructor() {
        makeAutoObservable(this)
    }

    setTool(tool: ToolStateType) {
        this.tool = tool
    }

    setFillColor(color: string) {
        if(this.tool) {
            this.tool.fillColor = color
        }
    }

    setStrokeColor(color: string) {
        if(this.tool) {
            this.tool.strokeColor = color
        }
    }

    setLineWidth(width: string) {
        if(this.tool) {
            this.tool!.lineWidths = +width
        }
    }

    clear() {
        if(this.tool) {
            socketState.socket?.send(JSON.stringify({
                method: MessageMethod.DRAW,
                id: socketState.sessionId,
                figure: {
                    type: FigureTypes.CLEAR
                }
            } as MessageType))
        }
    }

    clearAll() {
        if(this.tool) {
            this.tool.ctx?.clearRect(0, 0, this.tool.canvas?.width!, this.tool.canvas?.height!);
        }
    }
}

export default new ToolState()